import styled from 'styled-components';

const GooglePayButtonWrapper = styled.div`
  overflow: hidden;

  /* remove button stylings that are creating square border issues */
  .gpay-card-info-container.white.border-inset, .gpay-card-info-animation-container.white.border-inset {
    outline: none;
    &:hover {
      outline: none;
    }
  }
  .gpay-card-info-container.white, .gpay-card-info-animation-container.white {
    background-color: transparent;
    &:hover {
      background-color: transparent;
    }
  }

  /* create the button stylings that we desire */
  .google-pay-button-container {
    width: 100%;
    height: 2.9rem;
    border-radius: 2rem;
  }
  .google-pay-button-container:focus-within,
  .google-pay-button-container:focus,
  .google-pay-button-container:hover {
    outline: none;
  }
`;

export default GooglePayButtonWrapper;
